import React from "react";
import styled from "styled-components";

const ContactSection = styled.section`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
padding: 100px 20px;
text-align: center;
color: #ccd6f6;
min-height: 80vh;

@media (max-width: 768px) {
padding: 80px 1.5rem;
min-height: 70vh;
}
`;

const SectionNumber = styled.span`
color: ${({ theme }) => theme.colors.primary};
font-size: 1rem;
font-weight: bold;
margin-bottom: 1.25rem;
display: block;

@media (max-width: 768px) {
font-size: 0.9rem;
margin-bottom: 1rem;
}
`;

const Title = styled.h2`
font-size: 2.75rem;
color: ${({ theme }) => theme.colors.text};
margin: 0;
margin-bottom: 1.5rem;
line-height: 1.2;

@media (max-width: 768px) {
font-size: clamp(2rem, 7vw, 2.5rem);
margin-bottom: 1.25rem;
}
`;

const Description = styled.p`
font-size: 1.05rem;
max-width: 600px;
color: #8892b0;
margin-bottom: 2.5rem;
line-height: 1.7;

@media (max-width: 768px) {
font-size: clamp(0.95rem, 4vw, 1.05rem);
max-width: 100%;
margin-bottom: 2rem;
line-height: 1.8;
}
`;

const ContactButton = styled.a`
display: inline-block;
padding: 14px 32px;
border: 2px solid ${({ theme }) => theme.colors.primary};
border-radius: 4px;
color: ${({ theme }) => theme.colors.primary};
text-decoration: none;
font-weight: bold;
font-size: 1rem;
transition: 
background-color 0.3s ease, 
color 0.3s ease,
transform 0.2s ease;

&:hover {
background-color: ${({ theme }) => theme.colors.primary};
color: ${({ theme }) => theme.colors.background};
transform: translateY(-2px);
}

@media (max-width: 768px) {
padding: 12px 28px;
font-size: 0.95rem;
}
`;

const Contact = () => {
return (
<ContactSection id="contact">
<SectionNumber>04. What's Next?</SectionNumber>
<Title>Get In Touch</Title>
<Description>
I'm always excited to connect with fellow tech enthusiasts,
collaborators, and anyone curious about my work. If you have
questions, ideas, or just want to chat about innovative projects,
feel free to reach out. I'll do my best to respond as soon as
possible!
</Description>
<ContactButton href="mailto:haileleulfiseha@gmail.com">
Say Hello
</ContactButton>
</ContactSection>
);
};

export default Contact;
